@for (eula of appService.getEula(); track eula) {
  <button class="btn mb10" (click)="selectDoc(eula)" [ngClass]="_currentData.id == eula.id ? 'custom-border' : ''">{{eula.eula_title}}</button>
}

<div class="row" style="height: 80vh;">
  <div class="col-sm-12 col-md-12 col-lg-12 col-12">
    <div class="outer-container">
      <div >
        <pdf-viewer [config]="_currentData"></pdf-viewer>
      </div>
    </div>
  </div>
</div>